// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marginLeft200 {
  margin-left: 200px;
}   

.marginTop25 {
  margin-top: 25px;
}

.containerDivModerated {
    display: flex;
    flex-wrap: wrap;
}

.imageDivModerated {
    margin-left: 20px;
    margin-top: 50px;
    text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Moderated.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".marginLeft200 {\n  margin-left: 200px;\n}   \n\n.marginTop25 {\n  margin-top: 25px;\n}\n\n.containerDivModerated {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.imageDivModerated {\n    margin-left: 20px;\n    margin-top: 50px;\n    text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
